import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyNl = () => {
    return <SupportPrivacyPolicy languageCode="nl" />
}

export default SupportPrivacyPolicyNl
